import { DispatcherData } from '@owc-types/ComponentInitializeDispatcher';
import { isAemEditMode } from '@owc-utils/AEM';
import { ComponentOptionsWithProps } from 'vue/types/v3-component-options';

export type AEMMixinProps = {
  datajson: string;
  dataEditMode: boolean;
  dataAemModulename: string;
  dataAemModuletrackingname: string;
};

export type AEMMixinData = Partial<DispatcherData>;

export type AEMMixinComputed = {
  isEditMode: boolean;
};

export const props = {
  dataEditMode: {
    type: Boolean,
    default: false,
  },
  datajson: {
    type: String,
    required: false,
  },
  dataAemModulename: {
    type: String,
    required: false,
  },
  dataAemModuletrackingname: {
    type: String,
    required: false,
  },
};

const mixin: ComponentOptionsWithProps<AEMMixinProps, {}, AEMMixinData, {}, {}, {}, {}> = {
  computed: {
    json: function() {
      if (this.datajson) {
        return JSON.parse(this.datajson);
      }
      return undefined;
    },
    isEditMode() {
      return isAemEditMode(this.$parent!);
    },
  },
};

export default mixin;
